module.exports =
  '_CLUB_PAGE':
    'PAGE_TITLE': "Club"
    'SCORE_CARD': 'Score Card'
    'NO_ROUND_PLAYED': 'There is no round played on this course yet.'
    'HOLE_BY_HOLE_AVG': 'GN+ User\'s Average'
    'SHOT_AVG': 'Average Score'
    'PUTT_AVG': 'Average Put'
    'SCORE_AVG': 'Average Score'
    'PUTT_AVG_COUNT': 'Average Putt'
    'STROKE_PUTT': 'Stroke/Putt'
    'GIR_GIR1': 'GIR/GIR+1'
    'RECOVERY': 'Recovery'
    'ADDRESS': 'Address'
    'TEL': 'TEL'
    'URL': 'URL'
    'HEADER_TITLE_LARGE': 'GN+ User’s Score'
    'HEADER_TITLE_SMALL': '- Publishing 1 million of Score data -'
    'CHART_HEADING': 'Currently advising from score data of 1,200,000 people!'
    'CHANCE_HOLE': 'Chance Hole'
    'ONE_PUTT': 'Aim for! 1 putts'
    'DIFFICULT_HOLE': 'Difficult Hole'
    'THREE_PUTTS': '3 putts attention!'
    'YARDAGE': 'Yardage'
    'SEE_REVIEWS': 'Golf Course reviews See'
    'HOLE_ADVICE': 'Hole Advice'
    'COURSE_SELECT': 'Course Select'
    'BASIC_INFO': 'Golf course basic information'
    'RECOMMENT_PLAN': 'Recommend plan'
    'SEE_MORES_RECOMMENT_PLAN': 'See more recommend plan'
    'RECENT_PLAYED_USERS': 'Recently rounded users'
    'RANKING_USERS': 'Best score ranking'
    'RANK': 'Rank'
    'NAME': 'Name'
    'SCORE': 'Score'
    'RANKING_NOTICE': 'Target user : Nickname or name already set.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/i18n/en.coffee